export const dixaWebsiteUrl = 'https://www.dixa.com';
export const dixaLoginWebsiteUrl = 'https://accounts.dixa.com';
